var map = {
	"./game11.jpg": 9196,
	"./game12.jpg": 4325,
	"./game13.jpg": 7426,
	"./game14.jpg": 7952,
	"./game15.jpg": 4013,
	"./game16.jpg": 1696,
	"./game21.jpg": 5560
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8372;